module.exports = __webpack_public_path__ + "img/interests.44d7ec69.svg";